import clsx from "clsx";
import type { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import styles from "./recaptcha-notice.module.scss";

// Legal notice that must accompany any flow protected by reCAPTCHA Enterprise
// when the floating badge is hidden. Reference:
// https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
interface Props {
  className?: string;
}

export const RecaptchaNotice: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <p className={clsx(styles.recaptchaNotice, className)}>
      <Trans
        i18nKey="auth.recaptchaNotice"
        components={{
          privacyLink: (
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.recaptchaLink}
              aria-label={t("auth.recaptchaPrivacyPolicyAriaLabel", {
                defaultValue: "Google Privacy Policy (opens in a new tab)",
              })}
            >
              {" "}
            </a>
          ),
          termsLink: (
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.recaptchaLink}
              aria-label={t("auth.recaptchaTermsOfServiceAriaLabel", {
                defaultValue: "Google Terms of Service (opens in a new tab)",
              })}
            >
              {" "}
            </a>
          ),
        }}
      />
    </p>
  );
};
